import { Link } from "react-router-dom";
import { FaHome, FaArrowLeft } from "react-icons/fa";
import { motion } from "framer-motion";
import SEO from "../components/common/SEO";

const PageNotFound = () => {
    return (
        <>
        <SEO
            title="404 - Page Not Found | AZ Construction"
            description="Sorry, the page you are looking for could not be found. Return to AZ Construction's homepage to continue browsing."
            url="https://azconstruction.com/404"
        />
        <section className="min-h-screen flex items-center justify-center bg-slate-50 py-20">
            <div className="container-custom">

                <motion.div
                    initial={{
                        opacity: 0,
                        y: 50,
                    }}
                    animate={{
                        opacity: 1,
                        y: 0,
                    }}
                    transition={{
                        duration: 0.6,
                    }}
                    className="max-w-3xl mx-auto text-center"
                >

                    {/* 404 */}

                    <h1 className="text-[120px] md:text-[180px] font-black text-[#082B57] leading-none">
                        4<span className="text-[#F59E0B]">0</span>4
                    </h1>

                    {/* Heading */}

                    <h2 className="text-3xl md:text-5xl font-bold text-[#082B57] mt-4">
                        Oops! Page Not Found
                    </h2>

                    {/* Description */}

                    <p className="text-gray-600 text-lg mt-6 leading-8 max-w-2xl mx-auto">
                        The page you are looking for might have been moved,
                        deleted, or the URL may be incorrect.
                    </p>

                    {/* Buttons */}

                    <div className="flex flex-wrap justify-center gap-5 mt-10">

                        <Link
                            to="/"
                            className="bg-[#F59E0B] hover:bg-orange-600 text-white px-8 py-4 rounded-xl font-semibold flex items-center gap-3 transition"
                        >
                            <FaHome />
                            Back To Home
                        </Link>

                        <button
                            onClick={() => window.history.back()}
                            className="border-2 border-[#082B57] text-[#082B57] hover:bg-[#082B57] hover:text-white px-8 py-4 rounded-xl font-semibold flex items-center gap-3 transition"
                        >
                            <FaArrowLeft />
                            Go Back
                        </button>

                    </div>

                    {/* Construction Illustration */}

                    <div className="mt-12 flex justify-center">
                        <div className="w-32 h-32 rounded-full bg-[#082B57]/10 flex items-center justify-center">
                            <span className="text-6xl">🏗️</span>
                        </div>
                    </div>

                </motion.div>

            </div>
        </section>
        </>
    );
};

export default PageNotFound;